import { Component, Output, EventEmitter, Input, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, combineLatest, map } from 'rxjs';
import { IApiRobotConfiguration } from 'src/app/models_new/classes/api-models/ApiRobotConfiguration';
import { ObjectUtils } from 'src/app/utils/object';

interface ISortOption {
  label: string;
  value: string;
  selected: boolean;
}

@Component({
  selector: 'app-step-two',
  templateUrl: './step-two.component.html',
  styleUrls: ['./step-two.component.scss'],
})
export class StepTwoComponent implements OnInit {
  @Input() robotConfigs: IApiRobotConfiguration[];
  @Input() selectedRobotConfigsOnInit: IApiRobotConfiguration[];

  @Output() selectedConfigsEmitter: EventEmitter<IApiRobotConfiguration[]> =
    new EventEmitter();

  filteredRobotConfig$: Observable<IApiRobotConfiguration[]>;

  robotConfigSortOptions: ISortOption[] = [
    {
      label: 'Last edited',
      value: 'updated_at',
      selected: true,
    },
    {
      label: 'Name',
      value: 'name',
      selected: false,
    },
    {
      label: 'Creation Date',
      value: 'created_at',
      selected: false,
    },
    {
      label: 'Created By',
      value: 'owner_id',
      selected: false,
    },
  ];

  sortSubject: BehaviorSubject<ISortOption> = new BehaviorSubject(
    this.robotConfigSortOptions[0]
  );
  textFilterSubject: BehaviorSubject<string> = new BehaviorSubject('');

  ngOnInit(): void {
    this.filteredRobotConfig$ = combineLatest([
      this.sortSubject,
      this.textFilterSubject,
    ]).pipe(
      map(([sort_filter, text_filter]) => {
        let filteredConfigCards = this.robotConfigs;
        if (text_filter) {
          filteredConfigCards = this.robotConfigs.filter((c) =>
            c.name.toLowerCase().includes(text_filter.toLowerCase())
          );
        }

        if (sort_filter) {
          filteredConfigCards = ObjectUtils.orderBy(
            filteredConfigCards,
            [sort_filter.value],
            sort_filter.value === 'updated_at' ? ['desc'] : ['asc']
          );
        }
        return filteredConfigCards;
      })
    );
  }
}
